import { Instagram } from "lucide-react";
import Reveal from "../components/Reveal";
import { GALLERY, BRAND } from "../data/content";

export default function InstagramFeed() {
  const shots = GALLERY.slice(0, 6);
  return (
    <section data-testid="instagram-section" className="section-y relative">
      <div className="container-x">
        <Reveal className="flex flex-col items-center text-center">
          <span className="overline">@idealentertainment</span>
          <h2 className="mt-5 font-playfair text-3xl font-bold tracking-tight sm:text-4xl lg:text-5xl">
            Follow the experience
          </h2>
          <a
            href={BRAND.socials.instagram}
            target="_blank"
            rel="noreferrer"
            data-testid="instagram-follow"
            className="mt-6 inline-flex items-center gap-2 rounded-full border border-white/15 px-6 py-3 text-sm transition-all hover:border-gold hover:text-gold"
          >
            <Instagram size={18} /> Follow on Instagram
          </a>
        </Reveal>

        <div className="mt-12 grid grid-cols-2 gap-3 sm:grid-cols-3 lg:grid-cols-6">
          {shots.map((s, i) => (
            <Reveal key={i} delay={i * 0.04}>
              <a
                href={BRAND.socials.instagram}
                target="_blank"
                rel="noreferrer"
                data-testid={`instagram-post-${i}`}
                className="group relative block aspect-square overflow-hidden rounded-xl border border-white/5"
              >
                <img
                  src={s.src}
                  alt="Instagram"
                  loading="lazy"
                  className="h-full w-full object-cover transition-transform duration-700 group-hover:scale-110"
                />
                <div className="absolute inset-0 grid place-items-center bg-black/50 opacity-0 transition-opacity duration-300 group-hover:opacity-100">
                  <Instagram className="text-white" size={26} />
                </div>
              </a>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
